import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { AuthInterceptor } from './services/auth.interceptor';
import { FsHeaderComponent } from './components/fs-header/fs-header.component';
import { SidenavComponent } from './components/sidenav/sidenav.component';
import { NavbarComponent } from './components/navbar/navbar.component';
import { DashboardComponent } from './routes/dashboard/dashboard.component';
import { IncidentsComponent } from './routes/incidents/incidents.component';
import { TableComponent } from './components/table/table.component';
import { NewIncidentComponent } from './routes/incidents/new-incident/new-incident.component';
import { ReportsComponent } from './routes/reports/reports.component';
import { JumpersComponent } from './routes/jumpers/jumpers.component';
import { NewJumperComponent } from './routes/jumpers/new-jumper/new-jumper.component';
import { BoosterComponent } from './routes/booster/booster.component';
import { UsersComponent } from './routes/users/users.component';
import { AircraftComponent } from './routes/aircraft/aircraft.component';
import { ChutesComponent } from './routes/chutes/chutes.component';
import { PilotsComponent } from './routes/pilots/pilots.component';
import { BasesComponent } from './routes/bases/bases.component';
import { QualificationsComponent } from './routes/qualifications/qualifications.component';
import { DiagnosticComponent } from './routes/diagnostic/diagnostic.component';
import { DropdownComponent } from './components/dropdown/dropdown.component';
import { ButtonComponent } from './components/button/button.component';
import { FormComponent } from './components/form/form.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { WelcomeComponent } from './routes/welcome/welcome.component';
import { ToastComponent } from './components/toast/toast.component';
import { NewQualificationComponent } from './routes/qualifications/new-qualification/new-qualification.component';
import { NewPilotComponent } from './routes/pilots/new-pilot/new-pilot.component';
import { NewAircraftComponent } from './routes/aircraft/new-aircraft/new-aircraft.component';
import { NewChuteComponent } from './routes/chutes/new-chute/new-chute.component';
import { ModalComponent } from './components/modal/modal.component';
import { ComboboxComponent } from './components/combobox/combobox.component';
import { TransferJumperComponent } from './routes/jumpers/transfer-jumper/transfer-jumper.component';
import { EditLdoComponent } from './routes/jumpers/edit-ldo/edit-ldo.component';
import { NewBaseComponent } from './routes/bases/new-base/new-base.component';
import { RegisterComponent } from './routes/register/register.component';
import { SpinnerComponent } from './components/spinner/spinner.component';
import { MarsComponent } from './routes/mars/mars.component';
import { Mars3gridComponent } from './routes/mars3grid/mars3grid.component';
import { GalleryComponent } from './routes/mars/gallery/gallery.component';
import { SearchComponent } from './routes/mars/search/search.component';
import { MarsIncidentComponent } from './routes/mars/mars-incident/mars-incident.component';
import { IncidentComponent } from './routes/mars/components/incident/incident.component';
import { JumperComponent } from './routes/mars/components/jumper/jumper.component';
import { ParachutesComponent } from './routes/mars/components/parachutes/parachutes.component';
import { ArtifactsInfoComponent } from './routes/mars/components/artifacts-info/artifacts-info.component';
import { SummaryComponent } from './routes/mars/components/summary/summary.component';
import { VersionHistoryComponent } from './routes/version-history/version-history.component';
import { MarkdownModule } from 'ngx-markdown';

// Material Module
import { MaterialModule } from './material.module';
import { MatLegacyFormFieldModule as MatFormFieldModule } from '@angular/material/legacy-form-field';
import { NetworkInterceptor } from './services/network.interceptor';
import { MarsIncidentListComponent } from './routes/mars/mars-incident-list/mars-incident-list.component';
import { MatLegacyTableModule as MatTableModule } from '@angular/material/legacy-table';

// FSApps Next Gen
import { OAuthModule } from 'angular-oauth2-oidc';
import { CardComponent } from './components/card/card.component';
import { CookieService } from 'ngx-cookie-service';
import { MatSortModule } from '@angular/material/sort';
import { RegisteredComponent } from './routes/register/registered/registered.component';
import { ToolTipComponent } from './components/tool-tip/tool-tip.component'
import { AgGridModule } from 'ag-grid-angular';

// Pre2004JumpsComponent
import { Pre2004JumpsComponent } from './routes/pre2004jumps/pre2004Jumps.component';
import { EditPre2004JumpsComponent } from './routes/pre2004jumps/edit-pre2004jumps/edit-pre2004jumps.component';

@NgModule({
  declarations: [
    AppComponent,
    FsHeaderComponent,
    SidenavComponent,
    NavbarComponent,
    DashboardComponent,
    IncidentsComponent,
    TableComponent,
    NewIncidentComponent,
    ReportsComponent,
    JumpersComponent,
    NewJumperComponent,
    BoosterComponent,
    UsersComponent,
    AircraftComponent,
    ChutesComponent,
    PilotsComponent,
    BasesComponent,
    QualificationsComponent,
    DiagnosticComponent,
    DropdownComponent,
    ButtonComponent,
    FormComponent,
    WelcomeComponent,
    ToastComponent,
    NewQualificationComponent,
    NewPilotComponent,
    NewAircraftComponent,
    NewChuteComponent,
    ModalComponent,
    ComboboxComponent,
    TransferJumperComponent,
    EditLdoComponent,
    NewBaseComponent,
    RegisterComponent,
    SpinnerComponent,
    MarsComponent,
    Mars3gridComponent,
    GalleryComponent,
    SearchComponent,
    MarsIncidentComponent,
    IncidentComponent,
    JumperComponent,
    ParachutesComponent,
    ArtifactsInfoComponent,
    SummaryComponent,
    VersionHistoryComponent,
    MarsIncidentListComponent,
    CardComponent,
    RegisteredComponent,
    ToolTipComponent,
    Pre2004JumpsComponent,
    EditPre2004JumpsComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    FormsModule,
    ReactiveFormsModule,
    AppRoutingModule,
    MatSortModule,
    MatFormFieldModule,
    MaterialModule,
    HttpClientModule,
    AgGridModule,
    MarkdownModule.forRoot(),
    OAuthModule.forRoot({
      resourceServer: {
        allowedUrls: ['http://localhost:9091/'],
        sendAccessToken: true
      }
    })    
  ],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: NetworkInterceptor,
      multi: true
    },
    CookieService  
  ],
  bootstrap: [AppComponent]
})
export class AppModule {}
